import React from "react";
import { Plus } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PWA } from "@/constants/testIds";
import { FAQS } from "./data";
import Reveal from "./Reveal";

const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid={PWA.faqSection}
      className="relative bg-[#FAF9F6] py-24 md:py-32"
    >
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C4033] font-semibold mb-5">
                — Common Questions
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif-display text-[#1A1A1A] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                Answers, <br />
                <span className="italic text-[#5C4033]">straight up.</span>
              </h2>
            </Reveal>
            <Reveal delay={220}>
              <p className="mt-7 text-[#1A1A1A]/70 text-base md:text-lg leading-relaxed font-light">
                Not seeing your question? Give us a call — we'd rather talk it through.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={200}>
              <Accordion type="single" collapsible defaultValue={FAQS[0].key}>
                {FAQS.map((f) => (
                  <AccordionItem
                    key={f.key}
                    value={f.key}
                    data-testid={PWA.faqItem(f.key)}
                    className="border-b border-[#1A1A1A]/15"
                  >
                    <AccordionTrigger className="hover:no-underline py-6 group [&>svg]:hidden">
                      <span className="flex w-full items-center justify-between gap-4 text-left">
                        <span className="font-serif-display text-xl md:text-2xl text-[#1A1A1A] leading-tight">
                          {f.q}
                        </span>
                        <span className="faq-icon shrink-0 w-9 h-9 border border-[#1A1A1A]/30 flex items-center justify-center text-[#5C4033] group-hover:bg-[#5C4033] group-hover:text-[#FAF9F6] transition-all duration-300">
                          <Plus className="w-4 h-4 transition-transform duration-300" />
                        </span>
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="text-[#1A1A1A]/75 text-base md:text-lg leading-relaxed font-light pb-7 pr-12">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
